import React from "react";
import { MI_DOCUMENT_REVIEW_STEP, LAB_FOLLOWUP_STEPS, MI_SALESFORCE_MESSAGE_STEP } from "./screens/missinginfo_steps";
import { Wizard } from "./Wizard";
import { initialLabAnswers } from "./MissingInfoFollowupWizard";
import { clone } from "lodash-es";

export const LabFollowupWizard = ({
  caseId,
  caseUrl,
  commentsUrl,
  labTests,
  caseData,
  statusUrl,
  assigneeUrl,
  snoozeUrl,
  tasksUrl,
  nextStepUrl,
  submitUrl,
  miInfoUrl,
  missingFields,
  recordMiSalesforceContactUrl,
  createMiContactAttempt,
  updateCase,
  loading,
  moveToStepUrl,
  substatus,
  hasSupplementalDocuments,
  miCategories,
  initialMICategories,
  noMissingInfoUrl,
  submissionStep,
  submissionStepUrl,
}) => {
  let initialAnswers = clone(initialLabAnswers);
  let initialStep = MI_SALESFORCE_MESSAGE_STEP;

  if (missingFields) {
    initialAnswers.missingInfoFields = missingFields;
  }

  if (substatus) {
    initialAnswers.substatus = substatus;
  }

  return (
    <Wizard
      name="Missing Info Lab Followup"
      initialStep={initialStep}
      initialAnswers={initialAnswers}
      caseId={caseId}
      steps={LAB_FOLLOWUP_STEPS}
      caseUrl={caseUrl}
      commentsUrl={commentsUrl}
      labTests={labTests}
      caseData={caseData}
      statusUrl={statusUrl}
      assigneeUrl={assigneeUrl}
      snoozeUrl={snoozeUrl}
      tasksUrl={tasksUrl}
      nextStepUrl={nextStepUrl}
      submitUrl={submitUrl}
      miInfoUrl={miInfoUrl}
      missingFields={missingFields}
      createMiContactAttempt={createMiContactAttempt}
      updateCase={updateCase}
      recordMiSalesforceContactUrl={recordMiSalesforceContactUrl}
      loading={loading}
      moveToStepUrl={moveToStepUrl}
      miCategories={miCategories}
      initialMICategories={initialMICategories}
      noMissingInfoUrl={noMissingInfoUrl}
      submissionStep={submissionStep}
      submissionStepUrl={submissionStepUrl}
    />
  );
};
